import { GridSelectionExtraOptionsWebComponent } from './component/GridSelectionExtraOptionsWebComponent';
import { WEB_COMPONENT_GRID_SELECTION_EXTRA_OPTIONS } from '../../../webcomponents.constants';

export { GridSelectionExtraOptionsWebComponent };

window.customElements.define(WEB_COMPONENT_GRID_SELECTION_EXTRA_OPTIONS, GridSelectionExtraOptionsWebComponent);
